/** Lisans pasif (salt-okunur) yardımcıları — saf fonksiyonlar. */

export const VERI_DISA_AKTAR_IZNI = 'veri:disa-aktar';

/** Firma salt-okunur penceresinde mi (bitiş gelecekte)? */
export function saltOkunurModda(
  saltOkunurBitis: string | null | undefined,
  simdi: Date = new Date(),
): boolean {
  if (!saltOkunurBitis) return false;
  const t = new Date(saltOkunurBitis).getTime();
  return Number.isFinite(t) && t > simdi.getTime();
}

/** "22 Ekim 2026" biçiminde tarih. */
export function bitisTarihiMetni(saltOkunurBitis: string): string {
  return new Date(saltOkunurBitis).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/** Content-Disposition başlığından dosya adı (yoksa varsayılan). */
export function dosyaAdiCoz(disposition: string | null, varsayilan: string): string {
  const m = disposition?.match(/filename="?([^";]+)"?/i);
  return m?.[1] ?? varsayilan;
}
